<template>
  <div class="content">
    <div class="section3-left">
      <div class="s3-left-title">
        <span @click="goClick2(path1)" :style="{color:tabindex!=1?'#333333':'#015293'}" @mouseover="oneMouse(1)"
          ><a> {{ name1 }} </a></span
        >
        <span class="s3-left-title-spe">|</span>
        <span @click="goClick2(path2)" :style="{color:tabindex!=2?'#333333':'#015293'}" @mouseover="oneMouse(2)"
          ><a> {{ name2 }}</a></span
        >
      </div>
      <div>
        <ul>
          <li
            v-for="(item, index) in List.slice(0, 5)"
            :key="index"
            @click="goDetails1(item, goDetail1)"
          >
            <img src="../../static/image/home/list01.png" class="list1" /><a>{{
              item.title
            }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import lib from '../api/index';
export default {
  data() {
    return {
      List: [],
      oneList: [],
      twoList: [],
      tabindex:1
    };
  },
  props: {
    name1: String,
    name2: String,
    id1: Number,
    id2: Number,
    path1: String,
    path2: String
  },
  mounted() {
    this.getData('oneList', this.id1);
    this.getData('twoList', this.id2);
  },
  methods: {
    oneMouse(index) {
      this.tabindex=index
      if (index == 1) {
        this.List = this.oneList;
      } else if (index == 2) {
        this.List = this.twoList;
      }
    },
    getData(arr, id) {
      lib
        .appInformationList({
          params: {
            page: 1,
            size: 10,
            classifyId: id
          }
        })
        .then(res => {
          if (arr == 'oneList') {
            this.List = res.data.records;
          }
          this[arr] = res.data.records;
          // console.log(this.democraticList, 'democraticList', 'oo');
        });
    },
    //点击进入详情页
    goDetails1(item, names) {
      if (item.link == null || item.link == '') {
        this.$router
          .push({
            path: '/pageDetails',
            query: {
              id: item.id,
              name: names
            }
          })
          .catch(r => r);
      } else {
        location.href = item.link;
      }
    },
    //点击跳转子路由
    goClick2(path) {
      this.$router
        .push({
          path: path
        })
        .catch(r => r);
    }
  },
  computed: {
    goDetail1() {
      if (this.List == this.oneList) {
        return this.name1;
      } else if (this.List == this.twoList) {
        return this.name2;
      }
    }
  }
};
</script>
<style scoped>
a:hover {
  cursor: pointer;
  color: #ed0505;
}
.content {
  width: 32%;
  height: 100%;
  /* background-color: cadetblue; */
}
ul {
  margin-left: 10px;
  padding: 0;
}
ul li {
  width: 100%;
  height: 28px;
  line-height: 28px;
  margin-top: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list1 {
  margin-right: 3%;
}
.s3-left-title {
  width: 99%;
  height: 45px;
  line-height: 45px;
  padding-left: 1%;
  /* background-color: coral; */
  color: #015293;
  font-size: 20px;
  font-weight: bolder;
}
.s3-left-title a:hover {
  color: inherit;
}
.section3-left {
  width: 100%;
  height: 100%;
  /* background-color: cadetblue; */
}
.s3-left-title-spe {
  color: #999999;
  font-size: 20px;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/Content2.vue